import { render } from "./StyleguideApp.vue?vue&type=template&id=73249414&scoped=true"
const script = {}

import "./StyleguideApp.vue?vue&type=style&index=0&id=73249414&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73249414"]])

export default __exports__